// extracted by mini-css-extract-plugin
module.exports = {"form":"airdropVerify_form__H90Wl","loginForm":"airdropVerify_loginForm__FIvXE"};